import React from 'react';
import BubbleChart from '../CSSComponent/BubbleChart';
import BoxChart from '../CSSComponent/boxChart';
import Grid  from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import config from '../../config/config';
import {groupBy} from '../../util/grouping'
import {styles} from '../CSS/Styles'
import { font } from '../CSS/font'
import { withStyles } from '@material-ui/core/styles';
import CustomizedCard from '../CSSComponent/card'
import HorizontalBar from '../CSSComponent/horizontalBar'
// alpha will be set later in the dataset compose



const color_list=[
	"rgba(230, 25, 75, ", 
	"rgba(60, 180, 75, ", 
	"rgba(255, 225, 25, ", 
	"rgba(0, 130, 200, ", 
	"rgba(245, 130, 48, ", 
	"rgba(145, 30, 180, ", 
	"rgba(70, 240, 240, ", 
	"rgba(240, 50, 230, ", 
	"rgba(210, 245, 60, ", 
	"rgba(250, 190, 190, ", 
	"rgba(0, 128, 128, ", 
	"rgba(230, 190, 255, ", 
	"rgba(170, 110, 40, ", 
	"rgba(255, 250, 200, ", 
	"rgba(128, 0, 0, ", 
	"rgba(170, 255, 195, ", 
	"rgba(128, 128, 0, ", 
	"rgba(255, 215, 180, ", 
	"rgba(0, 0, 128, ", 
	"rgba(128, 128, 128, ", 
	"rgba(255, 255, 255, ", 
	"rgba(0, 0, 0, "
]

class VendorAlertTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        	vendor:[],
        	keyword:[],
        	selectedIndex: 0
        };
    }

    componentDidMount() {
    	axios.get(config.clusteranalysis).then((res)=>{
    		console.log(res)
    		this.setState({vendor:res.data})
    	})
    	axios.get(config.clusterkrywords).then((res)=>{
    		console.log(res)
    		this.setState({keyword:res.data})
    	})
    }

    clusterdataextract(){
        var clusterdata = groupBy(this.state.vendor, 'vendor_cluster')

		const data = []
		for (var key in clusterdata){

			var keyworditem = this.state.keyword.filter((obj)=>{return obj.Dominant_Topic==key.toString()})
			var keywordvalue = keyworditem[0].Keywords
			var cluster = clusterdata[key]
			var dataitem = {
				id:cluster[0].vendor_cluster,
				vendor:[],
				PO_amt: 0,
				PO_number: 0,
				keyword: keywordvalue
			}
			cluster.map((vendoritem)=>{
				dataitem.vendor.push({
					PCA1: vendoritem.PCA1,
					PCA2: vendoritem.PCA2,
					vendor_name: vendoritem.vendor_name,
					vendor_id: vendoritem.Vendor,

				})
				dataitem.PO_amt = dataitem.PO_amt + vendoritem.total_PO_amount
				dataitem.PO_number = dataitem.PO_number + vendoritem.no_of_po
			})
			data.push(dataitem)
		}

		return data
    }
	clusterdataFormating(data){
		const dataset = {
		  labels: ['January'],
		  datasets: []

		};
		for (var i = 0;i<data.length;i++){
			var point = data[i]

			var keywordlabel = point.keyword.split(', ')
			keywordlabel = keywordlabel.slice(0,3).join('\n')

			dataset.datasets.push(
				{
				  id: point.id,
		    	  label: keywordlabel,
		    	  backgroundColor: color_list[i] + "0.5)",
		    	  borderColor: color_list[i] + "1)",
		    	  pointBorderColor: color_list[i] + "1)",
		    	  pointBackgroundColor: color_list[i] + "1)",
		    	  pointBorderWidth: 1,
		    	  pointRadius: 1,
		    	  data: [{x:point.vendor.length, y:point.PO_amt, r:point.PO_number/4}]
		    	}
			)
		}
		return dataset
	}

    PCAdataextract(){
        var clusterdata = groupBy(this.state.vendor, 'vendor_cluster')

		const data = {
			vendor:[],
			keyword:'',
		}

		clusterdata[this.state.selectedIndex].map((vendoritem)=>{
			data.vendor.push({
				PCA1: vendoritem.PCA1,
				PCA2: vendoritem.PCA2,
				vendor_name: vendoritem.vendor_name,
				vendor_id: vendoritem.Vendor,
				mad_cluster : vendoritem.mad_cluster
			})
		})

		var keyworditem = this.state.keyword.filter((obj)=>{return obj.Dominant_Topic==this.state.selectedIndex.toString()})
		var keywordvalue = keyworditem[0].Keywords

		data.keyword = keywordvalue
		return data
    }
	PCAdataFormating(data){
		const dataset = {
		  labels: ['January'],
		  datasets: []
		};
		console.log(data)
		for (var i = 0;i<data.length;i++){
			var point = data[i]
			//console.log(point)
			dataset.datasets.push(
				{
				  id: point.vendor_id,
		    	  label: point.vendor_name,
		    	  backgroundColor:  color_list[this.state.selectedIndex] + point.mad_cluster/3 + ')',
		    	  borderColor:      color_list[this.state.selectedIndex] + '1' + ')',
		    	  pointBorderColor: color_list[this.state.selectedIndex] + '0.4' + ')',
		    	  pointBackgroundColor: '#fff',
		    	  pointBorderWidth: 1,
		    	  pointRadius: 1,
		    	  data: [{x:point.PCA1, y:point.PCA2, r:4}]
		    	}
			)
		}
		return dataset
	}



	handleBubbleClick=(index)=>{
		console.log("handle index " + index + "click")
		this.setState({selectedIndex: index})
	}



	render(){

		if(this.state.vendor.length==0 || this.state.keyword.length==0){
			return(
					<div/>
				)
		}

		const { classes } = this.props;

		const clusterdata = this.clusterdataextract()
		const dataset = this.clusterdataFormating(clusterdata)


		let vendorData = this.state.vendor
		const boxPlotXData = ['Total no. of POs',
			'Avg. no. of POs every 1 day',
			'Std Dev. of no. of POs every 1 day',
			'Percentage of POs created on non-working days',
			'Percentage of POs approved on non-working days',
			'Percentage of POs with rounded value ',
			'PO values (vendor\'s cluster)',
			'PO values (vendor)',
			'No. of unique creators',
			'No. of unique approvers',
			'Vendors with similar address'
		]

		const boxPlotYData = [vendorData.map(a => a.no_of_po),
			vendorData.map(a => a.no_of_po_pertime),
			vendorData.map(a => a.no_of_po_per_time_std),
			vendorData.map(a => a.percent_created_nwh),
			vendorData.map(a => a.percent_approved_nwh),
			vendorData.map(a => a.percent_round_value),
			vendorData.map(a => a.mad_cluster),
			vendorData.map(a => a.mad_vendor),
			vendorData.map(a => a.no_of_createdby),
			vendorData.map(a => a.no_of_approvedby),
			vendorData.map(a => a.no_of_similar_add)
		]
		
		const boxPlotColor = [color_list[0]+"0.5'",
			color_list[1]+"0.5'",
			color_list[2]+"0.5'",
			color_list[3]+"0.5'",
			color_list[4]+"0.5'",
			color_list[5]+"0.5'",
			color_list[6]+"0.5'",
			color_list[7]+"0.5'",
			color_list[8]+"0.5'",
			color_list[9]+"0.5'",
			color_list[10]+"0.5'",
		]


		//if (this.state.selectedIndex == -1){
		//	console.log(this.state.selectedIndex)
		//	return(
		//		<div>
		//			<Grid container spacing={1} style={{height:'60vh'}}>
		//				<Grid lg={12} item style={{height:'100%'}}>
		//					<Card style={{padding:"20px", height:'-webkit-fill-available'}}>
		//						<BubbleChart 
		//							title={['vendor cluster analysis']} 
		//							data={dataset}
		//							xLabel='No. of vendors (in cluster)'
		//							yLabel='Amount of payment'
		//							eEvent={this.handleBubbleClick}
		//							axisY='amount'
		//							height={2}
		//							width={7}
		//						/>	
		//					</Card>
		//				</Grid>
		//			</Grid>
		//		</div>
		//	)
		//}

		const PCAdata = this.PCAdataextract()
		const PCAdataset = this.PCAdataFormating(PCAdata.vendor)
		const vendorNo = PCAdata.vendor.length
		return(
			<div>
				<Grid container spacing={1} style={{height:'100%'}}>
					<Grid lg={10} item style={{height:'100%'}}>
						<CustomizedCard
							content={(
								<BubbleChart 
									title={['vendor cluster analysis']} 
									data={dataset}
									xLabel='No. of vendors (in cluster)'
									yLabel='Amount of payment'
									eEvent={this.handleBubbleClick}
									axisY='amount'
									height={2}
									width={7}
								/>	
							)}
							cardStyle={'2_3rd'}
							contentHeight = {'90%'}
						/>
					</Grid>
					<Grid lg={2} item style={{height:'100%'}}>
						<CustomizedCard
							header={'Vendors in cluster'}
							subheader={[(
									<Typography 
										className={classes.cardHeader} 
										style={{backgroundColor: color_list[this.state.selectedIndex]+'1)'}}>  
									</Typography>
								)]}
							content={(
								<List style={{height:'100%'}}>	
									{clusterdata[this.state.selectedIndex].vendor.map(vendor=>{
										return(
											<ListItem> 
												<Typography className={classes.font_family}>
													{vendor.vendor_name} 
												</Typography>
											</ListItem>
										)
									})}
								</List>
							)}
							cardStyle={'2_3rd'}
							contentHeight = {'80%'}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={1} style={{height:'100%'}}>
					<Grid lg={10} item style={{height:'100%'}}>
						<CustomizedCard
							content={(
								<BubbleChart 
									title={['vendor cluster analysis']} 
									data={PCAdataset}
									xLabel='PCA 1'
									yLabel='PCA 2'
									height={2}
									width={7}
									labelDisplay={false}
								/>	
							)}
							cardStyle={'2_3rd'}
							contentHeight = {'90%'}
						/>
					</Grid>
					<Grid lg={2} item style={{height:'100%'}}>
						<CustomizedCard
							header={'cluster detail'}
							subheader = {['No. of vendors: ' + {vendorNo}, 'Average PO amount per year: ', 'Unique characteristics: ']}
							content={(
								<List>	
									{PCAdata.keyword.split(', ').map(keyword=>{
										var listHeight = 40
										var vendorlist = this.state.vendor
										var frequency = vendorlist.filter((vendor)=>{ return vendor.keywords.includes(keyword)})
										return(
											<ListItem style={{height:listHeight+"px"}}> 
												<HorizontalBar
													label = {keyword}
													X = {10}
													Y = {0}
													height = {listHeight}
													length = {frequency.length*7}
													fillColor = {color_list[this.state.selectedIndex]+'0.4)'}
													strokeColor = {color_list[this.state.selectedIndex]+'1)'}
												/>
											</ListItem>
										)
									})}
								</List>
							)}
							cardStyle={'2_3rd'}
							contentHeight = {'70%'}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={1} style={{height:'100%'}}>
					<Grid lg={12} item>

						<CustomizedCard
							header={'box plot'}
							content={boxPlotXData.map((value, index)=>{
								return(
									<BoxChart
										xData = {[boxPlotXData[index]]}
										yData = {[boxPlotYData[index]]}
										color = {[boxPlotColor[index]]}
									/>	
								)
							})}
							contentHeight = {'90%'}
						/>
					</Grid>
				</Grid>
			</div>
		)
	}
}

export default withStyles(styles)(VendorAlertTable)


// WEBPACK FOOTER //
// ./src/components/Routines/VendorClusterAnalysis.js